import React from "react";
import * as Styles from "../../../../../../common-deprecated/styles/v2/toyota/custom/services/SharedService";
import FinancePackContent from "../step-services/FinancePackContent";
import type { PackType } from "../../../../../../common-deprecated/types/CommonTypes";
import { BnbLabel } from "../../../utils/labels";
import { useBnbSelector } from "../../../redux/store";

type FinancePackPropsType = {
    financePack: PackType;
    onlyShowSelected?: boolean;
};

const FinancePack = (props: FinancePackPropsType): JSX.Element => {
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const { financePack, onlyShowSelected } = props;

    return (
        <Styles.ServiceWrapper>
            {financePack.image && (
                <Styles.Banner>
                    <Styles.Image src={financePack.image} height={170} />
                </Styles.Banner>
            )}
            <Styles.TitleWrapper>
                <Styles.Title>{financePack.name}</Styles.Title>
                <Styles.ServiceTags>
                    {financeOption === "monthly" && (
                        <Styles.ServiceTag>
                            <BnbLabel label="financePackIncluded" />
                        </Styles.ServiceTag>
                    )}
                </Styles.ServiceTags>
            </Styles.TitleWrapper>

            {financePack.description && (
                <Styles.Description dangerouslySetInnerHTML={{ __html: financePack.description }} />
            )}
            <FinancePackContent pack={financePack} onlyShowSelected={onlyShowSelected} />
        </Styles.ServiceWrapper>
    );
};

export default FinancePack;
